import { create } from "zustand";

export const useAuthStore = create((set, get) => ({
	token: localStorage.getItem("token") || null,
	user: localStorage.getItem("user")
		? JSON.parse(localStorage.getItem("user"))
		: null,

	login: (token, user) => {
		localStorage.setItem("token", token);
		localStorage.setItem("user", JSON.stringify(user));
		set({ token, user });
	},

	logout: () => {
		localStorage.removeItem("token");
		localStorage.removeItem("user");
		set({ token: null, user: null });
	},

	isLoggedIn: () => {
		const token = localStorage.getItem("token");
		return !!token;
	},

	hasPermission: (...allowedRoles) => {
		const { user } = get();
		if (!user?.role) return false;
		return allowedRoles.includes(user.role);
	},

	canEdit: () => {
		const { user } = get();
		return ["admin", "manager"].includes(user?.role);
	},

	canCreate: () => {
		const { user } = get();
		return ["admin", "manager", "salesperson"].includes(user?.role);
	},

	isAdmin: () => {
		const { user } = get();
		return user?.role === "admin";
	},
}));
